module.exports = __webpack_public_path__ + "static/img/5.3ad358e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.jpg
// module id = vGcb
// module chunks = 1